<template>
  <div class="row">
    <div class="eight wide column">
      <div class="ui form">
        <p><strong>Short Name:</strong> {{ lesson.data.shortName }}</p>
        <p><strong>Start Day:</strong> {{ lesson.data.options.startDay }}</p>
        <p><strong>Image Link: </strong> {{ lesson.data.imageLink }}</p>
        <p v-if="lesson.data.options.primaryLink"><strong>Right Action Button Link:</strong> {{ lesson.data.options.primaryLink }}</p>
        <p v-if="lesson.data.options.secondaryLink"><strong>Left Action Button Link:</strong> {{ lesson.data.options.primaryLink }}</p>
        <p><strong>Belongs to Lesson Plan(s):</strong> {{ formattedLessonPlan }} </p>
        <p><i>Last modified on {{ new Date(lesson.data.lastModifiedTime).toLocaleDateString('en-CH', { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' }) }} (Local Time) by {{ lesson.data.lastModifiedByUser }}</i></p>


        <router-link :to="{ name: 'EditLessonPlan', params: { lessonid: lesson.id }}">
          <div class="ui button">Edit</div>
        </router-link>
      </div>
    </div>

    <div class="five wide column">
      <div class="ui sub header">Mobile Preview</div>
      <preview-lesson-plan
        :currentLesson="lesson"></preview-lesson-plan>
    </div>
  </div>
</template>

<script>
  /* TODO: This is the display layer of Lesson Plan Blocks after they have been created
  *  This component should support:
  *  1. R = Read and display the data
  *  2. U = Edit should allow the user to edit the data in place (e.g. editable?)
  *  3. D = Delete the target lesson plan block in place
  * */
  import {mapState} from 'vuex'
  import PreviewLessonPlan from './PreviewLessonPlan'

	export default {
    components: { PreviewLessonPlan },
	  props: {
	    lesson: {
	      type: Object,
        required: true
      }
    },
		data() {
			return {}
		},
		computed: {
      ...mapState(['coachingLessonPlansAll']),
      formattedLessonPlan: function () {
        if ( this.lesson.data.options.belongsToTemplate.length === 0) {
          return 'None'
        }
        else {

          let k = [];

          for (let i = 0; i < this.lesson.data.options.belongsToTemplate.length; i++) {
            let temp = this.coachingLessonPlansAll.find((element) => {
              return element.id === this.lesson.data.options.belongsToTemplate[i];
            });
            if (typeof(temp)!== 'undefined' && temp.data.deletedStatus === false) {
              k.push(temp.data.title);
            }
          }
          if (k.length === 0){
            return 'None'
          }
          else {
            return k.join(', ')
          }
        }
      }
    },
		methods: {},
		mounted() {

		}
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/content/LessonPlanRUD.vue